<div class="report-adjustments-navigation" fxLayout="column" fxFlex>
    @for (item of navigationItems(); track item.label) {
        <div
            class="report-adjustments-navigation__item"
            fxLayout="row"
            (click)="onNavigateChange.emit(item)"
            [class.disabled]="item.disabled"
        >
            <i
                class="fa-solid fa-chevron-right report-adjustments-navigation__icon-redirect"
            ></i>
            <div
                class="report-adjustments-navigation__icon-wrapper {{
                    item.icon && item.withOutIcon && 'contracted'
                }}"
                fxLayout="column"
                fxLayoutAlign="center center"
            >
                @if (item.icon && !item.withOutIcon) {
                    <i
                        class="fa-solid {{
                            item.icon
                        }} report-adjustments-navigation__icon"
                    ></i>
                } @else {
                    <img src="{{ item.image }}" alt="{{ item.label }}" />
                }
            </div>
            <div fxLayout="column" fxLayoutAlign="center start">
                <div fxLayout="row" fxLayoutAlign="center center">
                    <h2 class="report-adjustments-navigation__label">
                        {{ item.label }}
                        <div style="position: relative; left: 20px; top: -14px">
                            @if (!item.icon) {
                                <app-badge-rocket></app-badge-rocket>
                            }
                        </div>
                    </h2>
                </div>
                <p class="report-adjustments-navigation__description">
                    {{ item.description }}
                </p>
            </div>
        </div>
    }
</div>
